import classNames from "./dashboard.module.scss";

interface DashboardOverviewItemProps {
  label: string;
  value: number;
  iconColor: string;
  icon: string;
}

const DashboardOverviewItem = (props: DashboardOverviewItemProps) => {
  return (
    <div className={classNames.overviewItem}>
      <div className={classNames.overviewItemDetails}>
        <div className={classNames.overviewItemDetailsValue}>{props.value}</div>
        <div className={classNames.overviewItemDetailsLabel}>{props.label}</div>
      </div>

      <div className={classNames.overviewItemIcon}>
        <i
          className={"bi bi-" + props.icon}
          style={{ color: props.iconColor }}
        ></i>
      </div>
    </div>
  );
};

export default DashboardOverviewItem;
